import { useState } from "react";
import { deletarArquivoService } from "../../../services/deletarArquivoService";

export const useExcluirArquivo = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [success, setSuccess] = useState<string | null>("");
  const [error, setError] = useState<string | null>("");

  const resetError = () => setError(null);
  const resetSuccess = () => setSuccess(null);

  const excluirArquivo = async (arquivoId: number | null | undefined) => {
    try {
      const data = await deletarArquivoService(arquivoId);

      if (typeof data === "string") {
        // Ex: "Esse arquivo não pode ser excluído"
        setError(data);
        return;
      }

      if (typeof data === "object" && "status" in data && "error" in data) {
        // Ex: { status: 400, error: "Arquivo não encontrado" }
        setError(data.error || "Não foi possível excluir o arquivo.");
        return;
      }

      // Sucesso: retornou objeto do arquivo excluído
      setSuccess("Arquivo excluído com sucesso!");
    } catch (error) {
      console.error("Erro ao excluir Arquivo:", error);
      setError("Algo deu errado, entre em contato conosco.");
    } finally {
      setIsLoading(false);
    }
  };

  return {
    excluirArquivo,
    success,
    error,
    resetSuccess,
    resetError,
    isLoading,
  };
};
